import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes';

function App() {
  useEffect(() => {
    const loader = document.getElementById('app-loader');
    if (loader) loader.style.display = 'none';
  }, []);

   return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;

